import { render, staticRenderFns } from "./recommendation.vue?vue&type=template&id=f4ad2160&scoped=true"
import script from "./recommendation.vue?vue&type=script&lang=js"
export * from "./recommendation.vue?vue&type=script&lang=js"
import style0 from "./recommendation.vue?vue&type=style&index=0&id=f4ad2160&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ad2160",
  null
  
)

export default component.exports